import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Loader from "../Loader/loader";

const DutySlipList = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  loading,
}) => {
  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const baseImageURL = process.env.REACT_APP_IMAGE_URL; 

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  }; 

  function HandleChange(param) {
    GetId(param);
  }

 

  function getStatusColor(status) {
    switch (status) {
      case 'ACTIVE':
        return '#28A745';
      case 'INACTIVE':
        return '#DC3545';
      default:
        return 'blue';
    }
  }

  // console.log("userDetailResponseqqqqqq",userDetailResponse)
  return (
    <div className="container-fluid">
      <div className="cityList">
        <table>
          <thead>
            <tr className="cityListHeading">
              <th>S No.</th>
          
              <th>Lead id</th>
              <th>Execution Date</th>
              <th>Service Type</th>
              <th>Customer Name</th>
              <th>Sales Coordinator</th>
              <th>Operation Coordinator</th>
              <th>Amt.</th>
              <th>Status</th>
              <th>Action</th>
       
            </tr>
          </thead>
          {loading ? (
            <div style={{ position: "relative", left: "540px" }}>
              <Loader />
            </div>
          ) : (
            <tbody>
  {userDetailResponse?.length > 0 ? (
    userDetailResponse.map((slip, index) => (
      <tr key={slip.LeadID}>
        <td>{startIndex + index + 1}</td>
        <td>{slip.LeadID}</td>
        <td>{new Date(slip.ExecutionDate).toLocaleDateString()}</td>
        <td>{slip.ServiceType}</td>
        <td>{slip.CustomerName}</td>
        <td>{slip.SalesCoordinator}</td>
        <td>{slip.OperationCoordinator}</td>
        <td>{slip.Amt}</td>
        <td>
          <p
            style={{
              height: "30px",
              width: "100px",
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
              padding: "4px",
              borderRadius: "12px",
              backgroundColor: getStatusColor(slip.Status),
            }}
          >
            {slip.Status}
          </p>
        </td>
        <td>
          <button
            style={{ height: "30px", width: "38px" }}
            onClick={() => {
              setOpenProfile(!openProfile);
              HandleChange(slip.LeadID);
            }}
          >
            <SearchIcon className="icon" />
          </button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center" }}>
        No Duty Slips found
      </td>
    </tr>
  )}
</tbody>

          )}
        </table>
      </div>
    </div>
  );
};

export default DutySlipList;


